<template>
  <div>
    <!-- Directive -->
    <v-row>
      <v-col cols="4" class="py-0 col-lable">
        <label class="font-weight-bold">
          {{ $t("DIRECTIVE") }}
          <span class="red--text">*</span>
        </label>
      </v-col>
      <v-col class="pa-0">
        <v-textarea
          :spellcheck="false"
          dense
          outlined
          rows="2"
          v-model="formGeneral.leadSentence"
          :error-messages="leadSentenceErrors"
          @input="$v.formGeneral.leadSentence.$touch()"
          @blur="$v.formGeneral.leadSentence.$touch()"
        />
      </v-col>
    </v-row>
    <!-- Verb -->
    <v-row>
      <v-col cols="4" class="py-0 col-lable">
        <label class="font-weight-bold">
          {{ $t("VERB") }}
          <span class="red--text">*</span>
        </label>
      </v-col>
      <v-col class="pa-0">
        <v-text-field
          dense
          outlined
          v-model="formGeneral.verb"
          :error-messages="verbErrors"
          @input="$v.formGeneral.verb.$touch()"
          @blur="$v.formGeneral.verb.$touch()"
        />
      </v-col>
    </v-row>
    <!-- Question -->
    <v-row>
      <v-col cols="4" class="py-0 col-lable">
        <label class="font-weight-bold">
          {{ $t("QUESTION") }}
        </label>
      </v-col>
      <v-col class="pa-0 d-flex">
        <v-row class="ma-0 d-flex">
          <v-col class="pa-0">
            <v-text-field
              dense
              outlined
              class="mr-2"
              v-model="formGeneral.name1"
            />
          </v-col>
          <span
            v-for="(i, index) in formGeneral.answersConjugation"
            :key="index"
            class="mx-1"
            style="
              border-bottom: 2px solid #ccc;
              min-width: 1.5rem;
              height: 40px;
            "
          ></span>
          <v-col class="pa-0">
            <v-text-field
              dense
              outlined
              class="ml-2"
              v-model="formGeneral.name2"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <!-- Answer -->
    <v-row>
      <v-col cols="4" class="py-0 col-lable">
        <label class="font-weight-bold">
          {{ $t("CORRECT_ANSWER") }}
          <span class="red--text">*</span>
        </label>
      </v-col>
      <v-col class="pa-0">
        <v-row>
          <v-col
            class="pl-2 pa-0"
            style="max-width: 65px"
            cols="6"
            v-for="item in $v.formGeneral.answersConjugation.$each.$iter"
            :key="`answersConjugation-${item.$model.id}`"
          >
            <v-text-field
              class="ml-1 max-width-1"
              v-model="item.value.$model"
              :error-messages="answersErrors(item.value)"
              @input="item.value.$touch()"
              placeholder="あ"
              maxlength="2"
              hide-details
              @blur="validateValue(item.value)"
              dense
              outlined
            />
          </v-col>
        </v-row>
        <v-row class="ma-0 mt-1">
          <div class="v-text-field__details mb-2">
            <span
              class="red--text v-messages theme--light"
              v-if="$v.formGeneral.answersConjugation.$anyError"
              v-text="answersErrorMesssage"
            />
          </div>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="">
      <v-col cols="4" class="py-0 col-lable"></v-col>
      <v-col class="pa-0">
        <v-row class="ma-0">
          <v-col
            class="pl-4 pa-0"
            cols="6"
            style="max-width: 65px"
            v-for="(item, index) in $v.formGeneral.answersConjugation.$each
              .$iter"
            :key="`wrongAnswersConjugation-${item.$model.id}`"
          >
            <v-btn
              v-if="formGeneral.answersConjugation.length > 1"
              icon
              small
              outlined
              color="error"
              @click="handleDelete(index)"
            >
              <v-icon dark>fas fa-minus</v-icon>
            </v-btn>
          </v-col>
          <v-btn
            class="mx-2"
            icon
            small
            outlined
            color="success"
            v-if="formGeneral.answersConjugation.length < 7"
            @click="handleAddAnswers"
          >
            <v-icon dark>fas fa-plus</v-icon>
          </v-btn>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="mt-5">
      <v-col cols="4" class="py-0 col-lable">
        <label class="font-weight-bold">
          {{ $t("WRONG_ANSWER") }}
        </label>
      </v-col>
      <v-col class="pa-0">
        <v-row>
          <v-col
            class="pl-2 pa-0"
            cols="6"
            style="max-width: 65px"
            v-for="(item, index) in $v.formGeneral.wrongAnswersConjugation.$each
              .$iter"
            :key="`wrongAnswersConjugation-${item.$model.id}`"
          >
            <v-text-field
              class="ml-1 max-width-1"
              v-model="item.value.$model"
              :error-messages="wrongAnswersErrors(item.value, index)"
              @input="item.value.$touch()"
              placeholder="お"
              hide-details
              maxlength="2"
              @blur="validateValue(item.value)"
              dense
              outlined
            />
          </v-col>
        </v-row>
        <v-row class="ma-0 mt-2 ml-2">
          <div class="v-text-field__details mb-2">
            <span
              class="red--text v-messages theme--light"
              v-if="$v.formGeneral.wrongAnswersConjugation.$anyError"
              v-text="wrongAnswersErrorMesssage"
            />
          </div>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
export default {
  name: "FormConjugation",
  mixins: [validationMixin],
  props: ["parent"],
  store: ["formGeneral"],
  data() {
    return {
      imageError: false,
      format: /[^\u00BF-\u1FFF\u2C00-\uD7FF０-９Ａ-Ｚａ-ｚ_＿/／\s\w]/g,
      wrongAnsError: [],
    };
  },
  validations() {
    return {
      formGeneral: {
        answersConjugation: {
          required,
          $each: {
            value: {
              required,
              strongAnswers(answers) {
                return !this.format.test(answers); // checks for special char
              },
            },
          },
        },
        wrongAnswersConjugation: {
          $each: {
            value: {
              strongAnswers(answers) {
                return !this.format.test(answers); // checks for special char
              },
              isValid(value, answer) {
                const {
                  answersConjugation,
                  wrongAnswersConjugation,
                } = this.formGeneral;
                const answerIndex = wrongAnswersConjugation.findIndex(
                  (u) => u.id === answer.id
                );
                if (
                  answersConjugation[answerIndex].value != "" &&
                  answersConjugation[answerIndex].value == value
                ) {
                  return false;
                }
                return true;
              },
            },
          },
        },
        leadSentence: { required },
        verb: { required },
      },
    };
  },
  created() {
    this.formGeneral.leadSentence = "正しい形にしてください。";
  },
  computed: {
    leadSentenceErrors() {
      const errors = [];
      if (!this.$v.formGeneral.leadSentence.$dirty) return errors;
      !this.$v.formGeneral.leadSentence.required &&
        errors.push("指示文を入力してください。");
      return errors;
    },
    verbErrors() {
      const errors = [];
      if (!this.$v.formGeneral.verb.$dirty) return errors;
      !this.$v.formGeneral.verb.required &&
        errors.push("動詞を入力してください。");
      return errors;
    },
    answersErrorMesssage() {
      const { _ } = this;
      let error = "";
      _.forEach(
        this.$v.formGeneral.answersConjugation.$each.$iter,
        function (value) {
          if (value.$dirty && !value.required) {
            error = "正答を入力してください。";
          }
          if (value.$dirty && !value.strongAnswers) {
            error = "特殊文字以外を入力してください。";
          }
        }
      );
      return error;
    },
    wrongAnswersErrorMesssage() {
      const { _ } = this;
      let error = "";
      _.forEach(
        this.$v.formGeneral.wrongAnswersConjugation.$each.$iter,
        function (value) {
          if (value.$dirty && !value.strongAnswers) {
            error = "特殊文字以外を入力してください。";
          }
          if (value.$dirty && !value.isValid) {
            error = "正答以外のデータを入力してください。";
          }
        }
      );
      return error;
    },
  },
  methods: {
    async getParams() {
      this.$v.$touch();
      var params = "";
      if (!this.$v.$anyError) {
        const {
          leadSentence,
          name1,
          name2,
          isAnsewr,
          answersConjugation,
          verb,
          wrongAnswersConjugation,
        } = this.formGeneral;
        const { drillId } = this.$route.params;
        params = {
          sub_key: drillId,
          name: [],
          answer1: "",
          answer2: "",
          answer3: "",
          answer4: "",
          lead_sentence: leadSentence,
          audio: "",
          image: "",
          script: "",
          verb,
          answer_correct: [isAnsewr],
          sub_question: {
            question1: {
              answers: [
                {
                  id: 1,
                  name: "回答1",
                  value: "",
                },
                {
                  id: 2,
                  name: "回答2",
                  value: "",
                },
                {
                  id: 3,
                  name: "回答3",
                  value: "",
                },
                {
                  id: 4,
                  name: "回答4",
                  value: "",
                },
              ],
              audio: null,
              isAnsewr: 1,
              script: "",
            },
            question2: {
              answers: [
                {
                  id: 1,
                  name: "回答1",
                  value: "",
                },
                {
                  id: 2,
                  name: "回答2",
                  value: "",
                },
                {
                  id: 3,
                  name: "回答3",
                  value: "",
                },
                {
                  id: 4,
                  name: "回答4",
                  value: "",
                },
              ],
              audio: null,
              isAnsewr: 1,
              script: "",
            },
          },
          list_answer: {
            sentence_answer: [name1, name2],
            answer: [answersConjugation, wrongAnswersConjugation],
          },
        };
      }
      return params;
    },
    handleAddAnswers() {
      let answers = {
        id: this.formGeneral.wrongAnswersConjugation.length + 1,
        value: "",
      };
      this.formGeneral.wrongAnswersConjugation.push({ ...answers });
      this.formGeneral.answersConjugation.push({ ...answers });
    },
    handleDelete(index) {
      this.$delete(this.formGeneral.wrongAnswersConjugation, index);
      this.$delete(this.formGeneral.answersConjugation, index);
    },
    answersErrors(value) {
      if (value.$dirty && !value.required) {
        return "正答を入力してください。";
      }
      if (value.$dirty && !value.strongAnswers) {
        return "特殊文字以外を入力してください。";
      }
      return "";
    },
    wrongAnswersErrors(value) {
      if (value.$dirty && !value.strongAnswers) {
        return "特殊文字以外を入力してください。";
      }
      if (value.$dirty && !value.isValid) {
        return "正答以外のデータを入力してください。";
      }
      return "";
    },
    validateValue(value) {
      const { _ } = this;
      value.$touch();
      console.log("value: ", value);
      let valueCheck = [
        "きゃ",
        "きゅ",
        "きょ",
        "ぎゃ",
        "ぎゅ",
        "ぎょ",
        "しゃ",
        "しゅ",
        "しょ",
        "じゃ",
        "じゅ",
        "じょ",
        "ちゃ",
        "ちゅ",
        "ちょ",
        "ぢゃ",
        "ぢゅ",
        "ぢょ",
        "にゃ",
        "にゅ",
        "にょ",
        "ひゃ",
        "ひゅ",
        "ひょ",
        "びゃ",
        "びゅ",
        "びょ",
        "みゃ",
        "みゅ",
        "みょ",
        "ぴゃ",
        "ぴゅ",
        "ぴょ",
        "りゃ",
        "りゅ",
        "りょ",
      ];
      let check = _.find(valueCheck, (o) => o == value.$model);
      console.log("check: ", check);
      if (!check && value.$model.length == 2) {
        value.$model = "";
      }
    },
  },
};
</script>
